// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1MgHB","overflowing":"ReadFullNote_overflowing__JGWfi"};